module.exports = __webpack_public_path__ + "static/media/Shop-By-Lic-Plate.ec365b8a.svg";